/**
 * Abstract base class for protocol selection strategies.
 * Defines the contract for selecting appropriate staking protocols based on request context.
 * Strategies receive context information through method parameters rather than constructor injection.
 */
export class ProtocolSelectionStrategy {
    logger;
    constructor(logger) {
        this.logger = logger;
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicHJvdG9jb2wtc2VsZWN0aW9uLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vLi4vLi4vLi4vc3JjL21haW4vbW9kdWxlcy9zdGFraW5nL3Byb3RvY29scy9wcm90b2NvbC1zZWxlY3Rpb24vcHJvdG9jb2wtc2VsZWN0aW9uLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQWdCQTs7OztHQUlHO0FBQ0gsTUFBTSxPQUFnQix5QkFBeUI7SUFDMUIsTUFBTSxDQUFTO0lBRWxDLFlBQVksTUFBYztRQUN4QixJQUFJLENBQUMsTUFBTSxHQUFHLE1BQU0sQ0FBQztJQUN2QixDQUFDO0NBY0YifQ==